import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-plurionominal-min-input',
  templateUrl: './plurionominal-min-input.component.html',
  styleUrls: ['./plurionominal-min-input.component.less', './../plurinominal-input/plurinominal-input.component.less']
})
export class PlurionominalMinInputComponent {

  @Input() numberOfResolution: number;
  @Input() numberOfCandidates: number;
  @Input() numberOfVote = 1;
  @Input() index: number;
  @Input() temporality: string;
  @Input() votingType: string;
  @Output() sendNumberOfVote = new EventEmitter<number>();

  onVotersChanges($event) {
    const invalidCharacters = /[^0-9]/gi;
    const input = document.getElementById(`pluri-min-${this.index}`) as HTMLInputElement;

    if (invalidCharacters.test(input.value)) {
      input.value = input.value.replace(invalidCharacters, '');
    }
    if (Number(input.value) == 0 && $event.keyCode !== 8) {
      input.value = '1';
    }
    this.sendNumberOfVote.emit(Number(input.value));
  }
  onVotersDone() {
    const input = document.getElementById(`pluri-min-${this.index}`) as HTMLInputElement;
    if (input.value.length > 0) {
      if (Number(input.value) === 0) {
        input.value = '1';
        this.sendNumberOfVote.emit(Number(input.value));
      }
    } else {
      input.value = '1';
      this.sendNumberOfVote.emit(this.numberOfVote);
    }
  }
}
